export const SITE_URL =
  process.env.REACT_APP_SITE_URL?.replace(/\/$/, '') ?? 'https://lalafan.io';

export const DEFAULT_OG_IMAGE_URL =
  'https://attachments.lalafan.io/storage/assets/images/meta/og-image.png';

export const OG_IMAGE = {
  url: DEFAULT_OG_IMAGE_URL,
  width: 600,
  height: 315,
  type: 'image/png',
  alt: 'LALAFAN : 브랜드를 터뜨리는 가장 재미있는 방법',
} as const;

export const DEFAULT_SITE_META = {
  siteName: 'LALAFAN',
  title: OG_IMAGE.alt,
  description:
    '인플루언서와의 협업부터 콘텐츠 제작, 캠페인 운영, 오프라인 경험까지 하나의 플랫폼에서 시작하세요.',
  keywords:
    '라라팬, LALAFAN, 인플루언서 마케팅, 브랜드 마케팅, 콘텐츠 마케팅, 캠페인',
  locale: 'ko_KR',
  themeColor: '#111111',
} as const;

export type PageMetaConfig = {
  title: string;
  description: string;
};

export const PAGE_META: Record<string, PageMetaConfig> = {
  '/': {
    title: DEFAULT_SITE_META.title,
    description: DEFAULT_SITE_META.description,
  },
  '/contents': {
    title: 'CONTENTS | LALAFAN : 브랜드를 터뜨리는 가장 재미있는 방법',
    description:
      '콘텐츠 기획부터 제작까지, 브랜드에 맞는 콘텐츠 경험을 함께 만듭니다.',
  },
  '/campaigns': {
    title: 'CAMPAIGNS | LALAFAN : 브랜드를 터뜨리는 가장 재미있는 방법',
    description:
      '브랜드와 인플루언서가 함께 만든 다양한 캠페인 사례를 만나보세요.',
  },
  '/privacy': {
    title: '개인정보처리방침 | LALAFAN',
    description: '라라팬(LALAFAN) 개인정보처리방침입니다.',
  },
  '/terms-service': {
    title: '서비스 이용약관 | LALAFAN',
    description: '라라팬(LALAFAN) 서비스 이용약관입니다.',
  },
  '/test': {
    title: '메타데이터 테스트 | LALAFAN',
    description: 'Microlink API를 이용한 URL 메타데이터 조회 테스트 페이지입니다.',
  },
};

export const getPageMeta = (pathname: string): PageMetaConfig =>
  PAGE_META[pathname] ?? {
    title: DEFAULT_SITE_META.title,
    description: DEFAULT_SITE_META.description,
  };

export const getSiteUrl = (origin?: string) =>
  (origin ?? SITE_URL).replace(/\/$/, '');

export const getOgImageUrl = () => {
  const explicitUrl = process.env.REACT_APP_OG_IMAGE_URL?.trim();
  if (explicitUrl) return explicitUrl.replace(/\/$/, '');
  return DEFAULT_OG_IMAGE_URL;
};
